export const LOGIN_WITH_GOOGLE = '@LOGIN/LOGIN_WITH_GOOGLE';
export const CREATE_ACCOUNT = '@SIGNIN/CREATE_ACCOUNT';
export const LOGIN_WITH_EMAIL_AND_PASSWORD = '@LOGIN/LOGIN_WITH_EMAIL_AND_PASSWORD';
export const PUT_CREDENTIALS = '@LOGIN/PUT_CREDENTIALS';
export const LOG_OUT = '@LOGIN/LOG_OUT';
export const PUT_USER = '@LOGIN/PUT_USER';

export const actionCreators = {
    loginWithGoogle: () =>  ({ type: LOGIN_WITH_GOOGLE }),
    createAccount: (payload) =>  ({ type: CREATE_ACCOUNT, payload }),
    loginWithLoginAndPassword : (payload) =>  ({ type: LOGIN_WITH_EMAIL_AND_PASSWORD, payload }),
    putCredentials: (credentials) =>  ({ type: PUT_CREDENTIALS, payload: credentials }),
    logOut: () =>  ({ type: LOG_OUT}),
    putUser: (user) =>  ({ type: PUT_USER, payload: user })
}
